var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('DiscoverHeader'),_c('DiscoverBody'),_c('BlackBox',{attrs:{"customText":"show","title":_vm.$t('BlackBox.title-1'),"text":_vm.$t('BlackBox.text-1')}}),_c('Map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }